import {AlpineComponent} from 'alpinejs';

type FormJsData = {}

export default (): AlpineComponent<FormJsData> => ({
  init() {
    document.querySelectorAll<HTMLSelectElement>('.form-select').forEach((form) => {
      form.addEventListener('change', (event) => {
        if (event.target) {
          const target = event.target as HTMLSelectElement;
          form.classList.toggle('selected', target.value !== '');
        }
      });
      form.classList.toggle('selected', form.value !== '');
    });

    // The ajax fragment wrapper keeps the same id across a swap even though this component's own
    // element gets replaced (and thus destroyed) as part of it, so alpine-ajax dispatches
    // 'ajax:after' on window rather than on the (by then disconnected) triggering element.
    // Capture the stable id upfront and look up the fresh element once the swap has happened.
    const fragmentId = this.$el.closest<HTMLElement>('[id^="ajax-fragment-"]')?.id;

    window.addEventListener('ajax:after', () => {
      const target = (fragmentId && document.getElementById(fragmentId)) || this.$el;
      target.scrollIntoView({behavior: 'smooth', block: 'center'});

      // Same stable-sibling pattern as the fragment lookup above: the status div keeps a
      // predictable id (ajax-fragment-status-<uid> next to ajax-fragment-<uid>) across the swap,
      // so it can carry a reliable aria-live announcement plus a keyboard focus target for both
      // the validation-error re-render and the success message, neither of which the swap itself
      // announces or focuses.
      const uid = fragmentId?.replace('ajax-fragment-', '');
      const status = uid && document.getElementById(`ajax-fragment-status-${uid}`);
      if (status) {
        status.textContent = target.textContent?.trim() ?? '';
        status.focus();
      }
    }, {once: true});
  }
});
